import React from 'react';
import {
  CupSoda,
  Droplets,
  FlaskRound,
  Leaf,
  Shirt,
  Sparkles,
  SprayCan,
  Utensils,
  WashingMachine,
} from 'lucide-react';

const SUBCATEGORY_ICON_THEME = {
  food: {
    primaryIcon: Utensils,
    accentIcon: Leaf,
    gradient: 'linear-gradient(150deg, rgba(241, 223, 181, 0.94) 0%, rgba(214, 183, 124, 0.9) 100%)',
    borderColor: 'rgba(247, 234, 207, 0.95)',
    foreground: '#133027',
    accentBackground: 'rgba(250, 242, 226, 0.96)',
  },
  drink: {
    primaryIcon: CupSoda,
    accentIcon: Sparkles,
    gradient: 'linear-gradient(150deg, rgba(238, 217, 179, 0.94) 0%, rgba(208, 171, 115, 0.9) 100%)',
    borderColor: 'rgba(247, 234, 207, 0.95)',
    foreground: '#133027',
    accentBackground: 'rgba(250, 242, 226, 0.96)',
  },
  'loose-tea': {
    primaryIcon: FlaskRound,
    accentIcon: Leaf,
    gradient: 'linear-gradient(150deg, rgba(224, 236, 225, 0.94) 0%, rgba(175, 205, 182, 0.9) 100%)',
    borderColor: 'rgba(236, 245, 238, 0.95)',
    foreground: '#163829',
    accentBackground: 'rgba(244, 250, 245, 0.96)',
  },
  general: {
    primaryIcon: SprayCan,
    accentIcon: Sparkles,
    gradient: 'linear-gradient(150deg, rgba(199, 224, 214, 0.94) 0%, rgba(147, 185, 167, 0.9) 100%)',
    borderColor: 'rgba(225, 239, 233, 0.95)',
    foreground: '#0f3d2c',
    accentBackground: 'rgba(237, 247, 243, 0.96)',
  },
  dishwashing: {
    primaryIcon: Droplets,
    accentIcon: Sparkles,
    gradient: 'linear-gradient(150deg, rgba(207, 232, 216, 0.94) 0%, rgba(159, 205, 180, 0.9) 100%)',
    borderColor: 'rgba(225, 239, 233, 0.95)',
    foreground: '#0f3d2c',
    accentBackground: 'rgba(237, 247, 243, 0.96)',
  },
  laundry: {
    primaryIcon: WashingMachine,
    accentIcon: Shirt,
    gradient: 'linear-gradient(150deg, rgba(199, 224, 214, 0.94) 0%, rgba(147, 185, 167, 0.9) 100%)',
    borderColor: 'rgba(225, 239, 233, 0.95)',
    foreground: '#0f3d2c',
    accentBackground: 'rgba(237, 247, 243, 0.96)',
  },
  'solid-shampoos': {
    primaryIcon: Droplets,
    accentIcon: Leaf,
    gradient: 'linear-gradient(150deg, rgba(209, 232, 250, 0.94) 0%, rgba(122, 178, 221, 0.9) 100%)',
    borderColor: 'rgba(225, 241, 252, 0.95)',
    foreground: '#164B75',
    accentBackground: 'rgba(235, 246, 255, 0.96)',
  },
  soaps: {
    primaryIcon: Sparkles,
    accentIcon: Droplets,
    gradient: 'linear-gradient(150deg, rgba(209, 232, 250, 0.94) 0%, rgba(122, 178, 221, 0.9) 100%)',
    borderColor: 'rgba(225, 241, 252, 0.95)',
    foreground: '#164B75',
    accentBackground: 'rgba(235, 246, 255, 0.96)',
  },
};

const DEFAULT_THEME = SUBCATEGORY_ICON_THEME.food;

export function SubcategoryIcon({ subcategoryId, compact = true, className = '' }) {
  const theme = SUBCATEGORY_ICON_THEME[subcategoryId] || DEFAULT_THEME;
  const PrimaryIcon = theme.primaryIcon;
  const AccentIcon = theme.accentIcon;

  return (
    <span className={`relative inline-flex shrink-0 ${className}`} aria-hidden="true">
      <span
        className={`relative inline-flex items-center justify-center overflow-hidden border shadow-[0_10px_22px_rgba(0,0,0,0.14)] ${
          compact ? 'h-9 w-9 rounded-xl' : 'h-12 w-12 rounded-2xl'
        }`}
        style={{
          background: theme.gradient,
          borderColor: theme.borderColor,
        }}
      >
        <span className="absolute inset-[3px] rounded-[inherit] border border-white/45" />
        <PrimaryIcon
          className={compact ? 'h-4 w-4' : 'h-6 w-6'}
          style={{ color: theme.foreground }}
          strokeWidth={2.1}
        />
      </span>

      <span
        className={`absolute inline-flex items-center justify-center rounded-full border border-white/70 shadow-[0_8px_18px_rgba(0,0,0,0.2)] ${
          compact ? '-bottom-1 -right-1 h-4 w-4' : '-bottom-1 -right-1 h-6 w-6'
        }`}
        style={{ backgroundColor: theme.accentBackground }}
      >
        <AccentIcon
          className={compact ? 'h-2.5 w-2.5' : 'h-3.5 w-3.5'}
          style={{ color: theme.foreground }}
          strokeWidth={2.1}
        />
      </span>
    </span>
  );
}
